import { styled } from "@mui/material/styles";

export const LoadingWrapper = styled("div")(() => ({
  display: "flex",
  flex: 1,
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
}));

export const LoadingContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.text.primary,
  maxWidth: "432px",
}));

export const LoadingTitle = styled("div")(() => ({
  fontSize: "24px",
  fontWeight: 500,
  lineHeight: "32px",
  marginBottom: "16px",
  textAlign: "center",
}));

export const LoadingSubTitle = styled("div")(() => ({
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: "0.25px",
  textAlign: "center",
}));
